<template>
  <svg class="svg-icon" aria-hidden="true" @click="click">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
  export default {
    name: 'et-icon',
    props: {
      iconClass: {
        type: String,
        required: true
      }
    },
    computed: {
      iconName() {
        return `#${this.iconClass}`
      }
    },
    methods:{
      click(){

      }
    }
  }
</script>

<style>
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/ETIcon.vue